<template>
  <div class="row">
    <div class="col-sm-12 mb-0">
      <p>
        <span v-if="templateDisabledAt">Enable Template</span>
        <span v-else>Disable Template</span>
      </p>
    </div>
  </div>
  <ActionToolbar v-if="templateDisabledAt"
    :secondary-enabled="false"
    :component-state="currentState"
    :error-message="formError"
    :success-message="successMessage"
    primary-button-text="Enable Template"
    @primary-click.prevent="onSubmitEnable()" />
  <ActionToolbar v-else
    :secondary-enabled="false"
    primary-style="danger"
    :component-state="currentState"
    :error-message="formError"
    :success-message="successMessage"
    primary-button-text="Disable Template"
    @primary-click.prevent="onSubmitDisable()" />
</template>

<script>
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
import { useTemplateStore } from '@/src/stores/template';
import { savableStateMixin } from "@/src/mixins/savableStateMixin";

export default {
  components: {
    ActionToolbar
  },
  mixins: [ savableStateMixin ],
  props: {
    templateDisabledAt: { required: true },
    templateId: { required: true, type: String }
  },
  emits: ['load-template'],
  setup() {
    const templateStore = useTemplateStore();
    return {
      templateStore
    }
  },
  data() {
    return {
      lastAction: null
    }
  },
  computed: {
    successMessage() {
      if (this.lastAction == 'disabled') return 'Successfully disabled Template';
      if (this.lastAction == 'enabled') return 'Successfully enabled Template';
      return this.templateDisabledAt ? 'Successfully enabled Template' : 'Successfully disabled Template';
    }
  },
  methods: {
    async onSubmitDisable() {
      this.lastAction = 'disabled';
      await this.handleActivation('disabled');
    },
    async onSubmitEnable() {
      this.lastAction = 'enabled';
      await this.handleActivation('enabled');
    },
    async handleActivation(setState) {
      try {
        this.setSavableStateProcessing();
        const method = setState == 'disabled' ? this.templateStore.disableTemplate : this.templateStore.enableTemplate;
        const response = await method(this.templateId);
        this.$emit('load-template', response);
        this.setSavableStateSuccess();
      } catch(error) {
        this.handleFormError(error);
      }
    }
  }
}
</script>
